import React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate('/swipe');
    }
  }, [user, navigate]);

  return (
    <div style={{ fontFamily: 'Georgia, serif', background: '#FFFDF9', color: '#1C1410', overflowX: 'hidden' }}>

      {/* NAV */}
      <nav style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '1rem 2rem', background: 'rgba(255,253,249,0.95)', borderBottom: '1px solid rgba(184,146,74,0.2)' }}>
        <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1C1410' }}>
          Godly<span style={{ color: '#B8924A' }}>Match</span>
        </span>
        <button onClick={() => navigate('/login')} style={{ background: '#B8924A', color: '#fff', padding: '0.5rem 1.2rem', borderRadius: '2rem', border: 'none', cursor: 'pointer', fontSize: '0.9rem' }}>
          Sign In
        </button>
      </nav>

      {/* HERO */}
      <section style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '6rem 2rem 4rem', background: 'radial-gradient(ellipse 70% 60% at 50% 30%, rgba(184,146,74,0.1) 0%, transparent 70%)' }}>
        <div>
          <div style={{ display: 'inline-block', fontSize: '0.75rem', letterSpacing: '0.15em', textTransform: 'uppercase', color: '#B8924A', border: '1px solid #B8924A', padding: '0.4rem 1.2rem', borderRadius: '2rem', marginBottom: '2rem' }}>
            ✝ Christian Dating, Reimagined
          </div>
          <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 5rem)', lineHeight: 1.1, marginBottom: '1.2rem', fontWeight: 400 }}>
            Love Built on <em style={{ color: '#B8924A' }}>Faith</em>,<br />Not Just Feeling
          </h1>
          <p style={{ fontSize: '1.1rem', color: '#8C7B6E', maxWidth: '500px', margin: '0 auto 2rem', lineHeight: 1.7 }}>
            Godly Match connects Christian singles serious about relationships grounded in shared belief, prayer, and purpose.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button onClick={() => navigate('/signup')} style={{ background: '#B8924A', color: '#fff', padding: '0.9rem 2rem', borderRadius: '3rem', border: 'none', cursor: 'pointer', fontSize: '1rem', boxShadow: '0 4px 20px rgba(184,146,74,0.35)' }}>
              Create Your Profile — Free
            </button>
            <button onClick={() => navigate('/login')} style={{ background: 'transparent', color: '#B8924A', padding: '0.9rem 2rem', borderRadius: '3rem', border: '2px solid #B8924A', cursor: 'pointer', fontSize: '1rem' }}>
              Sign In
            </button>
          </div>
          <div style={{ marginTop: '3rem', display: 'flex', gap: '2.5rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            {[['12,000+', 'Active Members'], ['4.8 ★', 'App Rating'], ['800+', 'Couples Matched']].map(([num, label]) => (
              <div key={label} style={{ textAlign: 'center' }}>
                <strong style={{ display: 'block', fontSize: '2rem', color: '#1C1410' }}>{num}</strong>
                <span style={{ fontSize: '0.75rem', color: '#8C7B6E', textTransform: 'uppercase', letterSpacing: '0.08em' }}>{label}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section style={{ background: '#F5EFE6', padding: '5rem 2rem' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto', textAlign: 'center' }}>
          <span style={{ fontSize: '0.72rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: '#B8924A' }}>Simple & Intentional</span>
          <h2 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', marginTop: '0.5rem', marginBottom: '0.5rem', fontWeight: 400 }}>How Godly Match Works</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1.5rem', marginTop: '2.5rem' }}>
            {[
              ['🙏', 'Build Your Faith Profile', 'Share your denomination, values, and what you are looking for in a partner.'],
              ['💫', 'Discover Believers', 'Browse profiles matched by shared faith and life goals — not just photos.'],
              ['💬', 'Connect Meaningfully', 'Chat and grow a connection built on something real and lasting.'],
              ['❤️', 'Find Your Person', 'Meet someone who loves God as much as you do.'],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ background: '#fff', borderRadius: '1.2rem', padding: '2rem 1.5rem', border: '1px solid rgba(184,146,74,0.15)', textAlign: 'center' }}>
                <div style={{ fontSize: '2rem', marginBottom: '0.8rem' }}>{icon}</div>
                <h3 style={{ fontSize: '1.1rem', marginBottom: '0.5rem', fontWeight: 600 }}>{title}</h3>
                <p style={{ fontSize: '0.88rem', color: '#8C7B6E', lineHeight: 1.6 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIALS */}
      <section style={{ background: '#1C1410', padding: '5rem 2rem', textAlign: 'center' }}>
        <span style={{ fontSize: '0.72rem', letterSpacing: '0.18em', textTransform: 'uppercase', color: '#D4A96A' }}>Real Stories</span>
        <h2 style={{ fontSize: 'clamp(1.8rem, 3.5vw, 2.8rem)', color: '#FAF7F2', marginTop: '0.5rem', marginBottom: '2.5rem', fontWeight: 400 }}>Couples Who Found Each Other Here</h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem', maxWidth: '900px', margin: '0 auto' }}>
          {[
            ['"I had given up on dating apps. Godly Match was the first that felt designed for people who take their faith seriously."', 'Adaeze & Michael, Married 2024'],
            ['"We matched because of our values, not just our photos. That foundation changed everything."', 'Grace & Emmanuel, Engaged'],
            ['"The quality of people on this app is unlike anything else. Everyone is genuinely looking for something real."', 'Daniel, Lagos'],
          ].map(([quote, author]) => (
            <div key={author} style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(184,146,74,0.2)', borderRadius: '1.2rem', padding: '2rem', textAlign: 'left' }}>
              <div style={{ color: '#B8924A', marginBottom: '0.8rem' }}>★★★★★</div>
              <p style={{ fontSize: '0.92rem', color: 'rgba(250,247,242,0.8)', lineHeight: 1.7, marginBottom: '1rem' }}>{quote}</p>
              <div style={{ fontSize: '0.82rem', color: '#D4A96A', fontWeight: 500 }}>— {author}</div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section style={{ textAlign: 'center', padding: '5rem 2rem', background: 'radial-gradient(ellipse 60% 80% at 50% 50%, rgba(184,146,74,0.08) 0%, transparent 70%)' }}>
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 400, marginBottom: '1rem' }}>Your Story Could Start Today</h2>
        <p style={{ color: '#8C7B6E', maxWidth: '420px', margin: '0 auto 2rem', lineHeight: 1.7 }}>
          Join thousands of Christian singles who chose intention over impulse.
        </p>
        <button onClick={() => navigate('/register')} style={{ background: '#B8924A', color: '#fff', padding: '0.9rem 2rem', borderRadius: '3rem', border: 'none', cursor: 'pointer', fontSize: '1rem', boxShadow: '0 4px 20px rgba(184,146,74,0.35)' }}>
          Get Started — It is Free
        </button>
      </section>

      {/* FOOTER */}
      <footer style={{ background: '#1C1410', color: 'rgba(250,247,242,0.6)', padding: '2rem', textAlign: 'center', fontSize: '0.85rem' }}>
        <p style={{ marginBottom: '0.8rem' }}>© 2026 Godly Match. All rights reserved.</p>
        {['About', 'Privacy', 'Terms', 'Contact'].map(link => (
          <button key={link} onClick={() => navigate('/' + link.toLowerCase())} style={{ background: 'none', border: 'none', color: 'rgba(250,247,242,0.6)', margin: '0 0.8rem', cursor: 'pointer', fontSize: '0.85rem' }}>
            {link}
          </button>
        ))}
      </footer>

    </div>
  );
};

export default LandingPage;